import { createRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { authLayoutRoute } from '../layouts/auth-layout-route';
import { rootRoute } from '../__root';

const loginSearchSchema = z.object({
  redirect: z.string().optional(),
});

// This is will be /auth/login, because it's child of authLayoutRoute
export const loginRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/login',
  validateSearch: loginSearchSchema,
  component: lazyRouteComponent(() => import('@/pages/auth/login-page')),
});

// This route is used to redirect from /login to /auth/login, to prevent 404 error when user access /login directly
export const loginRedirectRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  beforeLoad: ({ context }) => {
    if (context.authStore.accessToken) throw redirect({ to: '/dashboard', replace: true });
    else throw redirect({ to: '/auth/login' });
  },
});
